import CityPageTemplate from "../city-template/CityPageTemplate";
import { petersburgVaConfig } from "./data";

export default function PetersburgVaPage() {
  return <CityPageTemplate config={petersburgVaConfig} />;
}